import React from 'react'
import { Field } from 'redux-form';

import { InputPicker, DinamicComponents, Item, painel } from 'scorpion-core'
import GantComponent from './components/GantComponent'

function componentRelEspelho(comp, dados) {
    return ""
}

function component(item, props) {
  
    return (<Item key={item.sha} style={{ flex: 1 }}>
        <Field name={item.field} item={item} component={GantComponent} />
    </Item>)

}

const modelo = {
    typeComponente: "PainelGant",
    field: "painelGant",
}

const comp = {
    typeComponente: "PainelGant",
    configView: {
        nome: "PainelGant",
        modelo
    },
    componentRelEspelho,
    component,
    // geraSubConfig: (form, c) => {
    //     let propsAdd = { rota: '/' + form.rota, someteComValor: c.someteComValor, titulo: c.label, customFormUid: form.uid, fluxo: c.field, propOrdemAux: c.ordenadorAux, fieldKanban: c.fieldKanban, confFluxo: c }
    //     return { rota: c.field, permissao: c.permissao ? form.permissao + "." + c.permissao : "", nomeMenu: c.label, ordemMenu: c.label, subDe: "", component: ViewFluxoKamban, propsAdd }
    // }
}

export default comp;


// WEBPACK FOOTER //
// ./src/routes/sistema/DinamicComponenets/components/Gant/index.js